module.exports = __webpack_public_path__ + "static/media/14.133653bc.jpg";